const parseQueryValue = (value) => {
  if (value === '') return [''];
  if (!value) return [];
  if (typeof value === 'string') {
    return value.split(',').filter((v) => v || v === '');
  }
  return Array.isArray(value) ? value : [];
};
export default parseQueryValue;
